import React, {memo, useState} from 'react'
import {
    Avatar,
    Drawer,
    FormControl,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from "@material-ui/core";
import {ProgressBar} from "components";
import SearchIcon from '@material-ui/icons/Search';

const DrawerList = memo(({open, close, list, position, loading}) => {
    const [filter, setFilter] = useState('');

    const handleChange = (event) => setFilter(event.target.value);

    const handleFilter = (fields) => {
        const {display_name, member_type} = fields;
        return display_name.toLowerCase().includes(filter.toLowerCase()) ||
            member_type.toLowerCase().includes(filter.toLowerCase());
    }

    return (
        <Drawer anchor={position} open={open} onClose={close}>
            <div style={{minWidth: 300, maxWidth: 300, overflowX: 'hidden'}}>
                <FormControl fullWidth style={{marginLeft: 5}}>
                    <InputLabel htmlFor="search">Search Member</InputLabel>
                    <Input id="search" value={filter} onChange={handleChange}
                           endAdornment={
                               <InputAdornment position="end">
                                   <IconButton> <SearchIcon/> </IconButton>
                               </InputAdornment>}
                    />
                </FormControl>
                <List>
                    {
                        list?.length > 0
                            ? list
                                .filter(handleFilter)
                                .map((listItem, index) => {
                                    const {display_name, member_type, color} = listItem;
                                    return (
                                        <ListItem button key={index}>
                                            <ListItemIcon><Avatar
                                                style={{backgroundColor: color}}>{display_name[0]}</Avatar></ListItemIcon>
                                            <ListItemText primary={display_name} secondary={member_type}/>
                                        </ListItem>
                                    )
                                })
                            : loading ? <ProgressBar/> : <div style={{textAlign: 'center'}}><h3>No User Found</h3></div>
                    }
                </List>
            </div>
        </Drawer>
    )
});

export default DrawerList;

DrawerList.defaultProps = {
    position: 'left',
    loading: false
};